export const requiredAttachAgreement = (value, { sendForApproval } = {}) => {
  if (value?.id === undefined && sendForApproval) {
    return 'Agreement is required';
  }
};
export const requiredFrameAgreement = (value, { sendForApproval } = {}) => {
  if (value?.id === undefined && sendForApproval) {
    return 'Frame Agreement is required';
  }
};

export const requiredAttachIO = (value, { sendForApproval } = {}) => {
  if (value?.id === undefined && sendForApproval) {
    return 'IO is required';
  }
};

export const requiredAgreementWithIo = (value, { sendForApproval } = {}) => {
  if (value?.id === undefined && sendForApproval) {
    return 'Agreement with IO is required';
  }
};

export const requiredAgreementUri = (value) => {
  if (!value?.uri) {
    return 'Agreement URL is required';
  }
};

export const validateUri = (value) => {
  if (
    /* eslint-disable-next-line */
    !/^(?:http(s)?:\/\/){1,1}[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$/.test(
      value?.uri
    )
  ) {
    return 'Wrong URL format';
  }
};

export const validateAgreementUri = (agreement, { sendForApproval }) => {
  let error = '';
  if (agreement || sendForApproval) {
    error = requiredAgreementUri(agreement);
    if (!error) {
      error = validateUri(agreement);
    }
    return error;
  }
};
